export interface SubmitPersonalInformationDto {
  firstName: string;
  lastName: string;
  fatherName: string;
  nationalId: string;
  certificateNo: string;
  birthDate: number;
  isMale: boolean;
  nationalCardFileUrl?: string;
}

export function toSubmitPersonalInformationFormData(
  dto: SubmitPersonalInformationDto,
): FormData {
  const formData = new FormData();

  formData.append('FirstName', dto.firstName);
  formData.append('LastName', dto.lastName);
  formData.append('FatherName', dto.fatherName);
  formData.append('NationalId', dto.nationalId);
  formData.append('CertificateNo', dto.certificateNo);
  formData.append('BirthDate', String(dto.birthDate));
  formData.append('IsMale', String(dto.isMale));

  if (dto.nationalCardFileUrl) {
    formData.append('NationalCardFileUrl', dto.nationalCardFileUrl);
  }

  return formData;
}
